import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


export default function MgmtAccordion() {
  return (
    <div className="Accordian">
    
        <Accordion style={{ backgroundColor: "white" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4a-content"
            id="panel4a-header"
          >
            <Typography>
              <h3>Management</h3>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div
                id="management-challenge"
                style={{ backgroundColor: "white", color: "black" }}
              >
                <div className="challenge-content">
                  <h1
                    className="orange text-center"
                    style={{ color: "#f49221" }}
                  >
                    Management
                  </h1>
                  <p>
                    <span className="orange">
                      <b>Instructions:</b>
                    </span>
                    <br />
                    Welcome to the Recruitment Challenge for the Management Subsystem. Pick the domain you're applying for and submit as a single PDF/link named FirstName_LastName_Domain. Keep raw/working files handy in case they come up in your interview.
You can choose as many domains as you want to. 
 Admin & Finance, PR & Publicity and Graphic Design tasks are compulsory to do. Partial submissions are also welcome.
                  </p>
                  <h2>
                    <u>Admin and Finance*</u>
                  </h2>
                  <p>
  NIDAR is MeitY and Drone Federation of India's national drone innovation
  challenge under the SwaYaan programme (NIDAR 2.0, 2026–27, launched 13 July
  2026). Assume MANAS's drone team has qualified for the Grand Finale in New
  Delhi. Plan the trip for a team of 5 (3 technical + 2 management), 4 days on
  ground.
</p>

<br />

<ul style={{ marginLeft: "20px" }}>
  <li>
    <strong>Travel</strong> — compare 2 options (flight/train) from Manipal to
    Delhi: cost, time, reasoning.
  </li>

  <br />

  <li>
    <strong>Stay</strong> — 2 realistic options near a central Delhi venue:
    cost/night, distance, fit for a group of 5.
  </li>

  <br />

  <li>
    <strong>Local transport</strong> — how the team + gear move around Delhi
    for 4 days.
  </li>

  <br />

  <li>
    <strong>Equipment handling</strong> — how to safely carry the drone,
    batteries, and gear, especially if flying.
  </li>
</ul>

<br />

<p>
  <strong>Deliverable:</strong>
</p>

<ul style={{ marginLeft: "20px" }}>
  <li>
    A one-page budget sheet (item / cost / qty / total → grand total).
  </li>

  <br />

  <li>
    A 150–250 word note justifying your key calls.
  </li>
</ul>
                  <h2>
                    <u>Graphic Design*</u>
                  </h2>
                  <p>
  Design a 4–6 slide Instagram carousel on <strong>ONE</strong> topic: your
  favourite travel destination, or a brochure-style carousel for your favourite
  car.
</p>

<br />

<ul style={{ marginLeft: "20px" }}>
  <li>
    Consistent colour palette and fonts across all slides.
  </li>

  <br />

  <li>
    Real, specific content (actual places/tips or actual specs/features).
  </li>

  <br />

  <li>
    At least one illustrated/graphic slide, plus a strong opener and clean
    closer.
  </li>
</ul>

<br />

<p>
  <strong>Deliverable:</strong>
</p>

<ul style={{ marginLeft: "20px" }}>
  <li>
    Exported JPG/PNG slides (numbered in order), or a Canva/Figma link.
  </li>
</ul>
                  <h2>
                    <u>PR & Publicity*</u>
                  </h2>
                  <p>
  <strong>Task A — Sponsorship Email:</strong> Write a cold outreach email to a
  real company, pitching sponsorship specifically for IGVC 2026 (our flagship
  international competition at Oakland University, Michigan) — make the case
  for IGVC itself. Include a sharp subject line, a brief intro with track
  record, the ask, why this company, what they get in return, and a clear next
  step. Max 250–300 words. (You do not have to actually mail the company right
  now)
</p>

<br />

<p>
  <strong>Task B — Instagram Post/Reel:</strong> Create an engaging recruitment
  post or reel of your choice (any format: reel, carousel, meme, static) plus a
  100–150 word caption with a strong hook and clear call to apply to Project
  MANAS.
</p>
                  <h2>
                    <u>Web Development</u>
                  </h2>
                    <p>
  Build <strong>ONE</strong> of the following two components using HTML and CSS
  (light vanilla JS is fine if it's needed to make things interactive).
  Whichever you pick, it should feel alive, not static and should adhere to
  MANAS's aesthetic (orange #F49221 /black).
</p>

<br />

<p>
  <strong>Option A — Interactive hero section</strong>
</p>

<ul style={{ marginLeft: "20px" }}>
  <li>
    A landing hero for Project MANAS with animated/hover-reactive elements —
    think a headline that reveals on scroll or load, a CTA button with a
    satisfying hover state, and some form of motion (parallax, subtle
    background animation, cursor-reactive elements, etc.)
  </li>
</ul>

<br />

<p>
  <strong>Option B — Dynamic photo gallery</strong>
</p>

<ul style={{ marginLeft: "20px" }}>
  <li>
    A gallery of MANAS's builds/events (use placeholder images) that's
    genuinely interactive — hover-to-expand, filterable categories, a lightbox
    on click, or a smooth grid-to-fullscreen transition.
  </li>
</ul>

<br />

<p>
  <strong>Deliverable:</strong>
</p>

<ul style={{ marginLeft: "20px" }}>
  <li>
    Files (zipped), or a live link (GitHub Pages/CodePen/Netlify).
  </li>

  <br />

  <li>
    Mention which option you picked.
  </li>
</ul>
                    <br />

<h2>
                    <u>Research</u>
                  </h2>
                  <p>
  MANAS needs <strong>4 brushed DC motors</strong> for the ground vehicle
  drivetrain — 24V, minimum 250W, driving the wheels of a ~40–50kg vehicle.
  Research two companies (ideally one international, one Indian) selling a
  motor that fits.
</p>

<br />

<ul style={{ marginLeft: "20px" }}>
  <li>
    <strong>For each:</strong> actual specs found, price,
    reliability/reputation, location &amp; shipping.
  </li>

  <br />

  <li>
    <strong>Recommend one company (100–150 words)</strong> — weigh price,
    reliability, and availability.
  </li>

  <br />

  <li>
    Outline a 3–4 step purchase plan.
  </li>
</ul>

<br />

<p>
  <strong>Deliverable:</strong>
</p>

<ul style={{ marginLeft: "20px" }}>
  <li>
    A 1–2 page report with a comparison table.
  </li>
</ul>
<br/>

<h2>
                    <u>Videography</u>
                  </h2>
                  <p>
  Create a <strong>15-second podcast intro</strong>. Use real clips of an
  existing podcaster, or build it entirely from text/animation.
</p>

<br />

<ul style={{ marginLeft: "20px" }}>
  <li>
    Grabs attention in the first 1–2 seconds.
  </li>

  <br />

  <li>
    Includes the podcast's name/branding (invent one).
  </li>

  <br />

  <li>
    Music tightly synced to cuts/animation.
  </li>

  <br />

  <li>
    Uses motion — not a static slideshow.
  </li>
</ul>

<br />

<p>
  <strong>Deliverable:</strong>
</p>

<ul style={{ marginLeft: "20px" }}>
  <li>
    Exported MP4 (Drive/YouTube unlisted link).
  </li>
</ul>
<br/>

                  <hr />
                  <br />
                  <h3>
                    <strong>Submission </strong>
                  </h3>
                  <p>
                    Email your answers and videos to{" "}
                    <a href="mailto:projectmanas.management@gmail.com ">
                      projectmanas.management@gmail.com
                    </a>
                    .
                  </p>
                  <p>
                    <b>NOTE: </b> The submissions over mail need to be
                    accompanied with the following details:
                    <ol>
                      <li>Full Name</li>
                      <li>Registration Number</li>
                      <li>Branch</li>
                      <li>Contact Number</li>
                    </ol>
                  </p>
                  <p>
                    {" "}
                    For any queries, please feel free to contact (Preferably
                    Whatsapp):{" "}
                  </p>
                  <div className="contact" align="center">
                    <p>
                      <b>Ishan </b>
                      <br /> +91 7355957870
                      <br />
                    </p>
                    <p>
                      <b>Keval </b>
                      <br /> +91 9833850133
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
    </div>
    );
}